const axios = require("axios");

module.exports = function (token) {
  return axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      Authorization: token,
    },
  });
};
